import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Accordion } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import { AiOutlineStar, AiTwotoneStar } from "react-icons/ai";
import { Typography } from "@mui/material";
import Swal from "sweetalert2";
import parse from 'html-react-parser';

import api from "../../_services/api";
import { clientesApi, pedidosApi, produtosApi } from "../OrderResumePag/_services/api";
import { useApp } from "../../contexts/AppContext";
import { useUserData } from "../../hooks/UserContext";
import notify from "../../components/UI/toast";

import PriceDetailProduct from "../../components/PriceDetailProduct";
import ImageBreak from "../../assets/image-break.png";
import { Banner, Content, CashbackInfo, StarIcon, Description, SoldBy, Title, Brand, VariationGrid, VariationSelect, VariationLabel, AccordionWrapper, ProductDivider, FixedFooter } from "./styles";
import ShippingEstimate from "../../components/ShippingEstimate";
import { trackViewItemMarketplace, trackMarketplaceAddToCart } from "../../utils/gtm";
import { useDispatch } from "react-redux";
import { getCart } from "../../Redux/cartSlice";

import { trackClick } from '../../utils/gtm';
import { tagIdFromLegacySuffix } from '../../utils/marketplaceTagIds';
import { useScreenTracking } from '../../hooks/useScreenTracking';

const formatTitle = (val) => {
  const title = val ? String(val).toLocaleLowerCase() : "";
  let result = "";
  switch (title) {
    case "size":
      result = "Tamanho";
      break;
    case "color":
      result = "Cor";
      break;
    case "voltage":
      result = "Voltagem";
      break;

    default:
      break;
  }
  return result;
};

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-default-wl",
    cancelButton: "btn btn-cancel-wl",
  },
  buttonsStyling: false,
  reverseButtons: true,
});

export default function ProductItem() {
  const { whitelabel } = useApp();
  const configData = whitelabel?.config || {};
  const channel = process.env.REACT_APP_DEFAULT_CHANNEL;
  const fatorFreteKey = `fator_${channel}_frete`;
  const fatorFrete = configData[fatorFreteKey] / 10000 || 0;

  const jwt = useUserData();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { user, addressShipping } = useUserData();
  const [data, setData] = useState([]);
  const [dataUser, setDataUser] = useState();
  const [enterJWT, setEnterJWT] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [variations, setVariations] = useState([]);
  const [wishlist, setWishList] = useState(false);
  const [displayMode, setDisplayMode] = useState(whitelabel?.payment_mode);
  const [selectedVariations, setSelectedVariations] = useState({});
  const [cartAdded, setCartAdded] = useState(false);
  const viewItemSentFor = useRef(null);

  const screenName = useScreenTracking();
  const trackClickBuyEvent = ({ title }) => {
      trackClick({
          title,
          contentType: "select_content",
          screenName,
          tagId: tagIdFromLegacySuffix("14"),
      });
  };

  useEffect(() => {
    setDisplayMode(whitelabel?.payment_mode);
  }, [whitelabel]);

  useEffect(() => {
    if (jwt.userData?.data && !enterJWT) {
      setEnterJWT(true);
      setDataUser(jwt.userData.data);
    }
    // eslint-disable-next-line
  }, [jwt.userData, enterJWT]);


  async function addCart(productSku) {
    const product = await pedidosApi.post(
      `v2/carrinho/${channel}`,
      {
        customerUuid: user.uuid,
        cep: user?.addresses.length ? user?.addresses[0].cep : addressShipping?.cep  || '05424000',
        sku: productSku,
        quantity: 1,
        fator: fatorFrete
      }
    )
    .then(async (res) => {
      const warnings = Object.values(res.data.data.warnings).flat();

      trackClickBuyEvent({title : 'comprar'})

      if(warnings.some(warning => warning.error)) {
        notify(warnings[0].message, "error");
        return;
      }

      trackMarketplaceAddToCart({
        itemId: data.uuid || id,
        itemName: data.label,
        discount: data.price?.BRL?.price && data.price?.BRL?.offer
          ? Math.max(0, parseFloat(data.price.BRL.price) - parseFloat(data.price.BRL.offer))
          : 0,
        index: 0,
        itemBrand: data.brand?.name || "",
        itemCategory: data.categories?.[0]?.name || data.category_name || "",
        price: parseFloat(data.price?.BRL?.offer || 0),
        quantity: 1,
      });

      const uuid = user.uuid;
      const cep = user?.addresses?.length ? user.addresses[0].cep : addressShipping?.cep;
      await dispatch(getCart({ uuid, cep, force: true })).unwrap();
      navigate("/loja/orderresume");

    })
    .catch((err) => {
      notify(err.response.data.message, "error");
    });
  }

  function handleChangeVariation(value, type) {
    const updatedSelections = { ...selectedVariations, [type]: value };
    setSelectedVariations(updatedSelections);

    const variationKeys = Object.keys(data.variations);
    const variationsList = Object.values(data.variations);

    const matchingVariation = variationKeys.find((uuid, idx) => {
      const variation = variationsList[idx];
      return Object.entries(updatedSelections).every(([k, v]) => variation[k]?.value === v);
    });

    if (matchingVariation) {
      navigate(`/loja/product/${matchingVariation}`);
    }
  }

  async function products(id) {
    const response = await produtosApi.get(
      "/v1/produto/" + id
    );
    return response.data.data;
  }

  async function apiWishlist() {
    if (!dataUser?.cpf) {
      console.warn("CPF não encontrado no dataUser, retornando array vazio para wishlist");
      return [];
    }
    
    try {
      const response = await clientesApi.get(
        `/customer/${dataUser.cpf}/wishlist`,
      );
      return response.data.data;
    } catch (error) {
      console.error("Erro ao buscar wishlist:", error);
      return [];
    }
  }

  async function onClickStar() {
    try {
      if (wishlist) {
        await clientesApi.delete(
          "/customer/" + user?.cpf + "/wishlist/product/" + id 
        );
        setWishList(false);
        notify("Produto removido dos favoritos", "success");
      } else {
        await clientesApi.post(
          "/customer/" + user?.cpf + "/wishlist",
          {
            product_uuid: id,
            customer_uuid: user?.uuid,
          }
        );
        setWishList(true);
        notify("Produto adicionado aos favoritos", "success");
      }
    } catch (e) {
      console.log("erro", e);
    }
    return "#";
  }

  const onImageError = (e) => {
    e.target.src = ImageBreak;
  };

  async function productCtr(id) {
    try {
      await produtosApi.post(
        "/v1/products/productCtr?product_uuid=" + id
      );
    } catch (error) {
      console.warn('Falha ao registrar visualização do produto:', error);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(() => true);

      try {
        const wishlistData = await apiWishlist();
        const response = await products(id);
        setData(response);
        setWishList(wishlistData.some((item) => item.product_uuid === id));

        productCtr(id);

        if (viewItemSentFor.current !== id) {
          trackViewItemMarketplace({
            itemId: response.uuid || id,
            itemName: response.label,
            discount: response.price?.BRL?.price && response.price?.BRL?.offer
              ? Math.max(0, parseFloat(response.price.BRL.price) - parseFloat(response.price.BRL.offer))
              : 0,
            index: 0,
            itemBrand: response.brand?.name || "",
            itemCategory: response.categories?.[0]?.name || response.category_name || "",
            price: parseFloat(response.price?.BRL?.offer || 0),
            quantity: 1,
          });
          viewItemSentFor.current = id;
        }

        setImages(response.images);
        if (response.variations) {
          setVariations(response.variations);
        }
        setLoading(false);
      } catch (error) {
        notify("Erro ao tentar carregar item", "error");
      }
    };

    if (user && user.cpf && id) fetchData();
  }, [user, id, dataUser]);

  useEffect(() => {
    if (data.variations && id) {
      const currentVariation = data.variations[id];
      if (currentVariation) {
        const currentSelections = {};
        Object.entries(currentVariation).forEach(([key, variation]) => {
          if (variation && variation.value) {
            currentSelections[key] = variation.value;
          }
        });
        setSelectedVariations(currentSelections);
      }
    }
  }, [id, data.variations]);

  return (
    !Loading && (
      <div className="wl-page">
        <div>
          <Banner>
            <StarIcon>
              {wishlist ? (
                <AiTwotoneStar
                  size={20}
                  style={{ color: whitelabel?.button_primary_color, cursor: "pointer" }}
                  onClick={() => onClickStar()}
                />
              ) : (
                <AiOutlineStar
                  size={20}
                  style={{ color: whitelabel?.button_primary_color, cursor: "pointer" }}
                  onClick={() => onClickStar()}
                />
              )}
            </StarIcon>
            <Carousel className="carousel-wl" variant="dark">
              {images.map((item, index) => {
                return (
                  <Carousel.Item key={index} className="test">
                    <img
                      className="d-block w-100"
                      src={item.path}
                      onError={onImageError}
                      /* alt={data.label} */
                    />
                  </Carousel.Item>
                );
              })}
            </Carousel>
          </Banner>
          <Content>
            {data?.cashback && parseFloat(data.cashback) > 0 && (
              <CashbackInfo className="mb-4">
                <Typography>{`Você vai ganhar ${parseFloat(
                  data?.cashback
                )}% de cashback`}</Typography>
              </CashbackInfo>
            )}

            {data?.stock && parseInt(data.stock) === 0 && (
              <p className="font-wl-700 text-xs color-text-warning mb-4">PRODUTO SEM ESTOQUE</p>
            )}

            <SoldBy>
              Vendido por: <span>{data.seller_name}</span>
            </SoldBy>

            <Title>{data.label}</Title>

            <Brand>
              {data?.brand?.name}
            </Brand>
            <PriceDetailProduct price={data?.price} displayMode={displayMode} />

            {data.variations && (() => {
              const variationGroups = {};
              Object.values(data.variations || {}).forEach((variationSet) => {
                Object.entries(variationSet).forEach(([key, variation]) => {
                  if (!variationGroups[key]) variationGroups[key] = new Set();
                  variationGroups[key].add(variation.value);
                });
              });
              const totalUniqueValues = Object.values(variationGroups).reduce((acc, set) => acc + set.size, 0);
              if (Object.keys(variationGroups).length === 1 && totalUniqueValues === 1) return null;

              return (
                <VariationGrid>
                  {Object.entries(variationGroups).map(([type, values]) => (
                    <div key={type}>
                      <VariationLabel>{formatTitle(type)}</VariationLabel>
                      <VariationSelect
                        value={selectedVariations[type] || ""}
                        onChange={(e) => handleChangeVariation(e.target.value, type)}
                      >
                        {[...values].map((val) => (
                          <option key={val} value={val}>{val}</option>
                        ))}
                      </VariationSelect>
                    </div>
                  ))}
                </VariationGrid>
              );
            })()}

            {/* Placeholder for ShippingEstimate - will be added in Task 4 */}
            <ShippingEstimate
              sku={data.sku}
              userCep={user?.addresses?.[0]?.cep || addressShipping?.cep}
              userAddress={user?.addresses?.[0]}
              userUuid={user?.uuid}
              onCartAdded={setCartAdded}
              displayMode={displayMode}
            />

            <ProductDivider />

            <AccordionWrapper>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Detalhes do produto</Accordion.Header>
                  <Accordion.Body>
                    {data.descriptionHtml ? (
                      <div className="font-wl-400 color-text-dark text-sm" dangerouslySetInnerHTML={{ __html: data.descriptionHtml }} />
                    ) : (
                      <Description className="font-wl-400 text-sm">{parse(data.description)}</Description>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </AccordionWrapper>
          </Content>
        </div>
        <FixedFooter>
          <Button
            onClick={() => {
              if (cartAdded) {
                trackClickBuyEvent({ title: 'comprar' });
                const uuid = user.uuid;
                const cepValue = user?.addresses?.length ? user.addresses[0].cep : addressShipping?.cep;
                dispatch(getCart({ uuid, cep: cepValue, force: true }));
                navigate("/loja/orderresume");
              } else {
                addCart(data.sku);
              }
            }}
            className="btn-default-wl text-xxs p-3 w-100"
            style={{ borderRadius: '9px' }}
            disabled={parseInt(data.stock) === 0}
          >
            COMPRAR
          </Button>
        </FixedFooter>
      </div>
    )
  );
}

ProductItem.propTypes = {
  product: PropTypes.object,
};
